export const colorsBackground = [
  '#FF3A30',
  '#F86721',
  '#C99D45',
  '#A5B3B4',
  '#821807',
  '#494D56',
]

export const colorsFonts = [
  '#F8F6EE',
  '#F8F6EE',
  '#F8F6EE',
  '#F8F6EE',
  '#F8F6EE',
  '#F8F6EE',
]
